import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import ContentGroupBadge from "./ContentGroupBadge";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(3),
  },
}));

const ContentGroupHeader = props => {
  const classes = useStyles();
  const { actions, breadcrumbs, loading, statusSwitch, view } = props;
  return loading ? (
    <Box height={80} width="100%">
      <PanelLoadingIndicator />
    </Box>
  ) : (
    <Grid
      className={classes.header}
      container
      justify="space-between"
      alignItems="center"
    >
      {breadcrumbs}

      <Grid item xs="auto">
        <Grid container alignItems="center">
          <ContentGroupBadge mediaType={view} />
          {statusSwitch}
          {actions}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContentGroupHeader;
